import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterHuisartsPage() {
  return <ClusterPageTemplate clusterName="Huisarts" sectorName="Zorgpraktijken" sectorSlug="zorgpraktijken" heroTitle="Website laten maken voor een huisartsenpraktijk" heroDescription="Een overzichtelijke, uiterst toegankelijke website voor jouw huisartsenpraktijk of gezondheidscentrum. Gericht op het snel informeren van patiënten." websiteOnderdelen={[{
    icon: 'PhoneIcon',
    title: 'Spoed & HAP',
    description: 'Direct zichtbare, niet te missen informatie voor levensbedreigende spoed en de huisartsenpost.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Praktijkinformatie',
    description: 'Heldere openingstijden, spreekuurtijden, telefonische bereikbaarheid en vakantieregelingen.'
  }, {
    icon: 'UsersIcon',
    title: 'Medewerkers',
    description: "Overzicht van de huisartsen, POH'ers, assistentes en hun specifieke spreekuren."
  }, {
    icon: 'FileTextIcon',
    title: 'Patiëntenportaal',
    description: 'Duidelijke verwijzing naar het portaal voor e-consults, herhaalrecepten en online afspraken.'
  }]} functionaliteiten={[{
    icon: 'ShieldCheckIcon',
    title: 'WCAG Toegankelijkheid',
    description: 'Ontworpen volgens richtlijnen voor digitale toegankelijkheid, zodat ook ouderen en slechtzienden de site goed kunnen gebruiken.'
  }, {
    icon: 'LaptopIcon',
    title: 'Portaal integratie',
    description: 'Naadloze doorverwijzing naar systemen zoals MijnGezondheid.net of Uw Zorg Online.'
  }, {
    icon: 'MessageSquareIcon',
    title: 'Nieuws & Mededelingen',
    description: 'Een makkelijk beheersbaar systeem voor belangrijke mededelingen zoals griepvaccinaties of vakantiesluitingen.'
  }]} siblingClusters={[{
    name: 'Fysiotherapie',
    slug: 'fysiotherapie'
  }, {
    name: 'Tandarts',
    slug: 'tandarts'
  }, {
    name: 'Psycholoog',
    slug: 'psycholoog'
  }]} faqs={[{
    q: 'Is de website goed leesbaar voor oudere patiënten?',
    a: 'Ja, wij ontwerpen met hoge contrasten, duidelijke lettertypes en een zeer logische navigatie, rekening houdend met de WCAG-richtlijnen voor toegankelijkheid.'
  }, {
    q: 'Kunnen we makkelijk een melding plaatsen bij vakantie of ziekte?',
    a: "Absoluut. We bouwen een 'alert-balk' in die je zelf met één klik kunt aanzetten bovenaan de website voor belangrijke mededelingen."
  }, {
    q: 'Wat kost een website voor een huisartsenpraktijk?',
    a: 'Een overzichtelijke, veilige praktijkwebsite start vanaf €1.500. We zorgen dat alle essentiële patiënteninformatie logisch is ingedeeld.'
  }, {
    q: 'Hoe linken we naar MijnGezondheid.net?',
    a: "We plaatsen opvallende, veilige knoppen op strategische plekken (zoals bij 'Afspraak maken' of 'Recepten') die patiënten direct naar jullie specifieke portaal-omgeving sturen."
  }]} data-id="element-1084" />;
}